import algoliasearch from "algoliasearch";

const client = algoliasearch("9M92AFELTS", "9fc580b99a078a341ab22d0796a53ebc");
const index = client.initIndex("products");
index.setSettings({
  hitsPerPage: 200,
});

export default index;
